import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { StammdatenSlice } from "./types";

const initialState: StammdatenSlice = {
	loaded: false,
	manifests: {}
};

export const {
	name: stammdatenSliceName,
	actions: { setStammdaten: setSDManifests },
	reducer: stammdatenReducer
} = createSlice({
	name: "stammdaten",
	initialState,
	reducers: {
		setStammdaten(state, action: PayloadAction<StammdatenSlice["manifests"]>) {
			return {
				loaded: true,
				manifests: action.payload
			};
		}
	}
});
